import { heroStats, topicTags, marqueeItems } from '@/mocks/home';

export default function Hero() {
  const pills = topicTags.slice(0, 5);

  return (
    <section id="top" className="relative w-full">
      <div className="relative w-full min-h-[560px] md:min-h-[680px] lg:min-h-[720px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20moody%20editorial%20background%20with%20layered%20smoke%20and%20torn%20paper%20textures%2C%20warm%20amber%20and%20deep%20terracotta%20side%20lighting%20on%20near%20black%20surface%2C%20dramatic%20vignette%2C%20cinematic%20contrast%20designed%20for%20overlay%20text%2C%20stylized%20artistic%20composition%2C%20high%20detail%2C%20no%20people&width=1600&height=900&seq=llhl-hero-01&orientation=landscape"
            alt="灵灵黑料完整版档案主视觉背景"
            title="灵灵黑料 完整版 深扒细节"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/75" />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/30 via-transparent to-accent-950/30" />

        <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-8 pt-28 pb-16 md:pt-32 md:pb-20 text-center ll-fade-up">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 backdrop-blur-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse" />
            <span className="text-xs md:text-sm font-label text-background-50/90 tracking-wide">
              社区自发整理 · 原帖留档持续更新
            </span>
          </div>

          <h2 className="mt-7 font-heading font-black text-background-50 text-4xl md:text-6xl lg:text-7xl leading-[1.08] tracking-tight">
            灵灵黑料
            <span className="block text-primary-300 mt-2 text-2xl md:text-4xl lg:text-5xl">
              深扒细节完整版
            </span>
          </h2>

          <p className="mt-7 max-w-2xl mx-auto text-sm md:text-base leading-relaxed text-background-50/80">
            原帖截图、未删内容与详细经过，按时间线一条条对回去。
            与其看拼凑的转述，不如把每一条灵灵黑料完整版摆在一起自己读。
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-2.5">
            {pills.map((t) => (
              <a
                key={t.id}
                href="#topics"
                className="px-3.5 py-1.5 rounded-full text-xs md:text-sm font-label text-background-50/85 bg-background-50/10 border border-background-50/20 backdrop-blur-sm hover:bg-background-50/20 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                #{t.label}
              </a>
            ))}
          </div>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#posts"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-base" />
              看完整版档案
            </a>
            <a
              href="#screenshots"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md border border-background-50/35 text-background-50 text-sm font-label hover:bg-background-50/10 transition-colors whitespace-nowrap"
            >
              <i className="ri-image-2-line text-base" />
              翻原帖截图
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-3 md:gap-6 max-w-2xl mx-auto">
            {heroStats.map((s) => (
              <div key={s.label} className="text-center">
                <div className="font-heading font-black text-background-50 text-2xl md:text-4xl">
                  {s.value}
                  <span className="text-xs md:text-sm font-body font-normal text-background-50/60 ml-1">
                    {s.unit}
                  </span>
                </div>
                <div className="mt-1 text-[11px] md:text-xs font-label text-background-50/65 tracking-wide">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 text-background-50/60">
          <span className="text-[11px] font-label tracking-[0.2em]">SCROLL</span>
          <i className="ri-arrow-down-line text-lg animate-bounce" />
        </div>
      </div>

      <div className="relative w-full bg-foreground-950 border-y border-foreground-800/60 overflow-hidden">
        <div className="flex w-max ll-marquee-track">
          {[...marqueeItems, ...marqueeItems].map((item, idx) => (
            <div key={`${item}-${idx}`} className="flex items-center gap-3 px-6 py-3 shrink-0">
              <i className="ri-flashlight-fill text-primary-400 text-xs" />
              <span className="text-xs md:text-sm font-label text-background-200/80 whitespace-nowrap">
                {item}
              </span>
              <span className="w-1 h-1 rounded-full bg-background-700" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}